export default function hash(value: unknown) {
    const s = JSON.stringify(value);

    let h = 0,
        i = 0;

    for (; i < s.length; i++) {
        h = (31 * h + s.charCodeAt(i)) << 0;
    }

    return String(h);
}
